import * as api from './api'

/**
 * Saha uygulamasındaki iş emri kilitleri.
 *
 * Kilitliyken web'den yazmak sunucuda engelleniyor (`IWorkOrderLockGuard`). Arayüzün bunu
 * ÖNCEDEN söylemesi gerekiyor: yalnız kaydederken hata veren bir ekran, kullanıcıya boşuna iş
 * yaptırıp sonunda reddediyor.
 *
 * **Neden tek yerde toplandı.** Kilit bilgisi iş emri view'larına kolon olarak eklenmedi
 * (ikisi de veritabanında tanımlı view, eklemek göç isterdi); onun yerine tek uç var. Aynı
 * ekranda birden fazla iş emri kartı olabildiği için her biri kendi isteğini yapsaydı aynı
 * cevap defalarca çekilirdi. Burada uçuşan istek paylaşılıyor ve sonuç kısa süre saklanıyor.
 *
 * Saklama süresi bilerek kısa: kilit, sahadaki teknisyen senkronladığı anda kalkıyor ve
 * ekranın bunu geç fark etmesi, olmayan bir kilit yüzünden kullanıcıyı durdurmak demek.
 */

/** Cevabın tazelik ömrü. */
const TTL_MS = 15000

let cachedAt = 0
let cached = null
let inFlight = null

/** Sunucudan gelen satırı iş emri kimliğine göre haritaya çevirir. */
function toMap(rows) {
  const map = {}
  ;(rows || []).forEach((row) => {
    map[row.WorkOrderId] = row
  })
  return map
}

/**
 * Açık kilitler: `{ [workOrderId]: { LockedByUserId, LockedByName, LockedAt, IsMine } }`.
 *
 * Hata durumunda boş harita dönüyor, istisna atmıyor: kilit bilgisi ekranın SÜSÜ değil ama
 * onsuz da ekran çalışmalı. Sunucuya ulaşılamadığı için iş emri detayının hiç açılmaması,
 * kilit göstermemekten çok daha kötü. Yazma yine de sunucuda engelleniyor.
 */
export async function getWorkOrderLocks({ force = false } = {}) {
  if (!force && cached && Date.now() - cachedAt < TTL_MS) return cached
  if (!force && inFlight) return inFlight

  inFlight = api
    .getWorkOrderLocks()
    .then((res) => {
      cached = res.body && res.body.IsSuccess ? toMap(res.body.Data) : {}
      cachedAt = Date.now()
      return cached
    })
    .catch(() => ({}))
    .finally(() => {
      inFlight = null
    })

  return inFlight
}

/** Tek bir iş emrinin kilidi; yoksa null. */
export async function getWorkOrderLock(workOrderId, options) {
  const locks = await getWorkOrderLocks(options)
  return locks[workOrderId] || null
}

/**
 * Saklanan cevabı geçersiz kılar.
 *
 * Kilit kaldırıldıktan sonra çağrılıyor: aksi hâlde ekran on beş saniye boyunca kalkmış bir
 * kilidi göstermeye devam eder ve kullanıcı düğmeye ikinci kez basar.
 */
export function invalidateWorkOrderLocks() {
  cached = null
  cachedAt = 0
}

/**
 * Kilidi kaldırır ve saklanan cevabı geçersiz kılar.
 *
 * Kilidi yalnız sahibi kaldırabilir; sunucu başkasının isteğini 409 ile reddediyor.
 */
export async function releaseWorkOrderLock(workOrderId) {
  await api.releaseWorkOrderLock(workOrderId)
  invalidateWorkOrderLocks()
}
